// TODO: Labels are passed as props because chat copy + `useAlbertineTranslation`
// live in albertine-shared-web, which already depends on this package (circular if we
// import the other way). Look at moving i18n resources/hook into `@albertine/i18n`
// (or another library) so chat components can call `t()` in place and drop these bags.
export type ChatMessageLabels = {
    reply: string;
    copy: string;
    sendingMessage: string;
    sendingMessageFailed: string;
    preferredOptions: string;
    imageAttachmentAlt: string;
    retrySend: string;
    dismissSelection: string;
    addReaction: string;
    moreActions: string;
    reactWith: string;
    removeReaction: string;
    closeImage: string;
    playVoice: string;
    pauseVoice: string;
    voiceProgress: string;
    downloadFile: string;
    openImage: string;
    fileAttachmentFallback: string;
    imageAttachmentFallback: string;
    replyImage: string;
    replyAudio: string;
};

export type ChatInputLabels = {
    send: string;
    attachFile: string;
    expand: string;
    collapse: string;
    recordVoice: string;
    discardVoice: string;
    sendVoice: string;
    micPermission: string;
    micNotFound: string;
    unableToRecord: string;
};

export const defaultChatMessageLabels: ChatMessageLabels = {
    reply: "Reply",
    copy: "Copy",
    sendingMessage: "Sending...",
    sendingMessageFailed: "Couldn't send the message. Tap to try again.",
    preferredOptions: "Preferred options",
    imageAttachmentAlt: "Image attachment: {{filename}}",
    retrySend: "Retry sending the message",
    dismissSelection: "Dismiss selected message",
    addReaction: "Add reaction",
    moreActions: "More actions",
    reactWith: "React with {{reaction}}",
    removeReaction: "Remove {{reaction}} reaction",
    closeImage: "Close image",
    playVoice: "Play voice message",
    pauseVoice: "Pause voice message",
    voiceProgress: "Voice message progress",
    downloadFile: "Download {{filename}}",
    openImage: "Open {{filename}}",
    fileAttachmentFallback: "file attachment",
    imageAttachmentFallback: "image attachment",
    replyImage: "Image",
    replyAudio: "Audio",
};

export const defaultChatInputLabels: ChatInputLabels = {
    send: "Send message",
    attachFile: "Attach file",
    expand: "Expand input",
    collapse: "Collapse input",
    recordVoice: "Record voice message",
    discardVoice: "Discard voice message",
    sendVoice: "Send voice message",
    micPermission: "Microphone permission is required to record a voice message",
    micNotFound: "No microphone was found on this device",
    unableToRecord: "Unable to record a voice message",
};

export function formatChatLabel(
    template: string,
    vars: Record<string, string>,
): string {
    let result = template;
    for (const [key, value] of Object.entries(vars)) {
        result = result.replaceAll(`{{${key}}}`, value);
    }
    return result;
}
